import type { TrackingDesignConfig } from 'src/modules/designStudio/types';

import { DesignConfigCategories } from './designConfig';

const EmptyTrackingDesignConfig = {
  [DesignConfigCategories.WALL]: { texture: undefined, color: undefined },
  [DesignConfigCategories.ROOF]: { texture: undefined, color: undefined },
  [DesignConfigCategories.TRIM]: { texture: undefined, color: undefined },
  [DesignConfigCategories.WINDOW]: { texture: undefined, color: undefined },
} as TrackingDesignConfig;

export { EmptyTrackingDesignConfig };
